module.exports = __webpack_public_path__ + "static/media/corporateStep6.945340a9.svg";